export default __webpack_public_path__ + "static/review1-de355fa77078441aa76a63d6c49109a0.png";